import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactNode } from 'react';

type Props = { description: ReactNode };
export const CustomHelpTooltip = (props: Props) => (
  <Tooltip
    title={props.description}
    enterTouchDelay={0}
    leaveTouchDelay={3000}
    slotProps={{
      tooltip: {
        className: 'bg-primary/90 p-sm',
        sx: { maxWidth: 360 },
      },
    }}
  >
    <IconButton>
      <HelpOutlineIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);
